import { Stack } from '@mui/material'
import { styled } from '@mui/system'
import { graphql } from 'gatsby'
import * as React from 'react'
import { useIntl } from "react-intl"
import parse from 'html-react-parser';
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const RootDiv = styled(Stack)({
	width: "calc(100% - 90px)",
  height: "calc(100vh - 130px)",
  borderTop: "3px solid #6a7077",
  margin: "45px 45px 0 45px",
  overflow: "auto",
})
const TitleDiv = styled('div')({
	color: "#575e63",
  fontSize: "24px",
  width: "20%",
  height: "100%",
	fontWeight: "600",
	margin: "0",
  top: "13px",
  left: "0px",
})
const DivButtonAbout = styled(Stack)({
  margin: "40% 0 0 10px"
})
const DivGroupButton = styled(ToggleButtonGroup)({
})
const ButtonAbout = styled(ToggleButton)({
  margin: "0",
  border: "0",
  color: "#575e63",
  fontWeight: "600",
})
const TextDiv = styled('div')({
  width: "60%"
})
const TitleTextDiv = styled('h2')({
  fontSize: "24px",
	fontWeight: "600",
  color: "#575e63",
})
const ContentTextDiv = styled('div')({
  borderTop: "1px solid #6a7077",
  margin: "70px 0 0 0",
	fontWeight: "500",
	fontStyle: "italic",
  fontSize: "16px",
  color: "#575e63",
	lineHeight: "30px",
	paddingBottom: "100px",
  "& p": {
    margin: "0"
  }
})

export default function Apropos ({data}) {
  const intl = useIntl()
  const allTexts = data.swapi.allTexts;
  const [menu, setMenu] = React.useState(0)

  const handleClickMenu = (menu) => {
    setMenu(menu)
  }

  return (
    <RootDiv direction="row">
		<TitleDiv>
      <DivButtonAbout direction="column" alignItems="flex-start" justifyContent="flex-start">
        <DivGroupButton role="tablist" orientation="vertical" variant="text" value={menu}>
          {allTexts.map((text, i) => {
            let title = text.translations.find(t => t.lang === intl.locale).title;
            let isSelected = allTexts[menu].translations.find(t => t.lang === intl.locale).title === title;
            return (
              <ButtonAbout role="tab" key={i} onClick={() => {handleClickMenu(i)}} sx={{fontWeight: ((isSelected) ? '800' : '600')}}>
                {title}
              </ButtonAbout>
            )
          })}
        </DivGroupButton>
      </DivButtonAbout>
		</TitleDiv>
		<TextDiv>
			<TitleTextDiv>
				{allTexts[menu].translations.find(t => t.lang === intl.locale).title}
			</TitleTextDiv>
			<ContentTextDiv variant="body" component="p">
				{parse(allTexts[menu].translations.find(t => t.lang === intl.locale).text)}
			</ContentTextDiv>
		</TextDiv>
    </RootDiv>
  )
}


export const query = graphql`
  query Apropos {
  swapi {
    allTexts {
      page
      translations {
        id
        lang
        text
        title
      }
    }
  }
}
`